import React from "react";
import { Box, Card, CardContent, Grid, Typography, useTheme } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Link } from "react-router-dom";
import { tokens } from "../../theme";
import { legalAccent } from "./LegalBlocks";

const RELATED = [
  {
    path: "/privacypolicy",
    title: "Privacy Policy",
    description: "How we collect, use and protect your personal information.",
  },
  {
    path: "/cookiepolicy",
    title: "Cookie Policy",
    description: "The cookies and similar technologies this website uses.",
  },
  {
    path: "/terms",
    title: "Terms of Service",
    description: "The terms that apply when you use this website.",
  },
  {
    path: "/contact",
    title: "Contact Us",
    description: "Questions about any of the above? Get in touch.",
  },
];

/**
 * Cross-links to the other legal documents. Shown at the foot of every legal page so a
 * reader who lands on one policy can reach the others without going back to the footer.
 */
const RelatedPolicies = ({ currentPath }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const accent = legalAccent(theme);

  const items = RELATED.filter((item) => item.path !== currentPath);

  return (
    <Box component="aside" sx={{ mt: { xs: 6, md: 8 } }}>
      <Typography
        variant="h5"
        sx={{
          textTransform: "uppercase",
          letterSpacing: "0.08em",
          color: theme.palette.text.secondary,
          mb: 2.5,
        }}
      >
        Related
      </Typography>
      <Grid container spacing={2}>
        {items.map((item) => (
          <Grid item xs={12} sm={4} key={item.path}>
            <Card
              component={Link}
              to={item.path}
              onClick={() => window.scrollTo(0, 0)}
              sx={{
                display: "block",
                height: "100%",
                textDecoration: "none",
                backgroundColor: colors.background[300],
                border: `1px solid ${theme.palette.divider}`,
                transition: "transform 0.3s ease-in-out",
                "&:hover": { transform: "translateY(-4px)" },
                "&:focus-visible": {
                  outline: `2px solid ${accent}`,
                  outlineOffset: "2px",
                },
              }}
            >
              <CardContent>
                <Typography
                  variant="h5"
                  sx={{
                    color: theme.palette.text.primary,
                    mb: 1,
                    display: "flex",
                    alignItems: "center",
                    gap: 0.5,
                  }}
                >
                  {item.title}
                  <ArrowForwardIcon sx={{ fontSize: 18, color: accent }} />
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ color: theme.palette.text.secondary, lineHeight: 1.7 }}
                >
                  {item.description}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default RelatedPolicies;
